<template>
    <div class="row">
        <div class="col-12 position-relative mb-5">
            <h5 class="text-center" v-if="file === false">FILE UPLOAD</h5>
            <h5 class="text-center" v-else>EDIT FILE</h5>
            <a href="#!"
               class="qf-close-modal"
               @click.prevent="closeFileModal">
                <font-awesome-icon icon="times"/>
            </a>
        </div>
        <div class="col-12">
            <form @submit.prevent="uploadFile" ref="fileUploadModal">
                <div class="row">
                    <div class="col-12 col-sm-7 mb-3">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label for="description">Title</label>
                                <input type="text"
                                       class="form-control"
                                       id="description"
                                       name="description"
                                       v-model="fileName"
                                       v-validate="'required'"
                                       :class="{'is-invalid': errors.has('description')}">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label for="tagsInput">Tags</label>
                                <tags-input
                                        element-id="tags"
                                        v-model="selectedTags"
                                        :inputId="'tagsInput'"
                                        :existing-tags="tagOptions"
                                        :typeahead="true"
                                        :typeahead-style="'dropdown'"
                                        :typeahead-activation-threshold="0"
                                ></tags-input>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-5 mb-3">
                        <div class="qf-dropzone" v-if="file === false">
                            <div class="qf-dropbox-content d-flex align-items-center justify-content-center"
                                 :class="{'qf-dropbox-hover': fileDragOver, 'dropzone-invalid': errors.has('file')}"
                                 @dragenter="fileDragOver=true" @dragend="fileDragOver=false"
                                 @dragleave="fileDragOver=false">
                                <div class="text-center p-3" v-if="!imageBase64">
                                    <h5 class="text-uppercase">
                                        <strong>{{fileName.length?fileName:'Drag File'}}</strong>
                                    </h5>
                                    <div class="qf-chose-file" v-if="!fileName.length">
                                        {{$ml.get('Chose_File')}}
                                    </div>
                                </div>
                                <div class="text-center" v-else>
                                    <img :src="imageBase64" class="img-fluid" alt="" v-if="imageBase64">
                                </div>
                                <input type="file"
                                       name="document"
                                       accept="*"
                                       @change="filesChange($event)"
                                       v-validate="'required'">
                            </div>
                        </div>
                        <div class="qf-dropzone qf-disabled-disabled" v-else>
                            <div class="qf-dropbox-content d-flex align-items-center justify-content-center">
                                <div class="text-center p-3" v-if="!file.file_type.includes('image')">
                                    <h5 class="text-uppercase">
                                        <strong>{{file.original_name}}</strong>
                                    </h5>
                                </div>
                                <div class="text-center" v-else>
                                    <img :src="imageUrl" class="img-fluid" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="progress" v-if="file === false">
                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning"
                                 role="progressbar"
                                 :style="{width: `${progress}%`}"
                                 :aria-valuenow="progress"
                                 aria-valuemin="0"
                                 aria-valuemax="100"></div>
                        </div>
                        <div class="w-100 text-center" v-else-if="loading">
                            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-right">
                        <button class="btn btn-outline-dark" @click="closeFileModal" :disabled="progress > 0">
                            <font-awesome-icon icon="times"/>&nbsp;&nbsp;&nbsp;Cancel
                        </button>
                    </div>
                    <div class="col">
                        <button v-if="file === false" type="submit" class="btn btn-warning" :disabled="progress > 0">
                            <font-awesome-icon icon="upload"/>&nbsp;&nbsp;&nbsp;Upload
                        </button>
                        <button v-else type="submit" class="btn btn-warning">
                            <font-awesome-icon icon="save"/>&nbsp;&nbsp;&nbsp;Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from "axios/index";
    import TagsInput from '../../common/TagsInput'

    export default {
        name: "UploadFileModal",
        props: {
            id: [String, Number],
            file: [Object, Boolean]
        },
        components: {
            TagsInput
        },
        computed: {
            imageUrl() {
                let baseUrl = process.env.VUE_APP_API_URL;
                if (this.file !== false) {
                    return `${baseUrl}brand/${this.id}/document/${this.file.id}?access_token=${localStorage.getItem('user-token')}`;
                } else {
                    return '';
                }
            },
            tagOptions() {
                let result = this.$store.state.tags.map(tag => {
                    return {key: tag, value: tag}
                });
                return result;
            }
        },
        data() {
            return {
                fileDragOver: false,
                imageBase64: null,
                fileName: '',
                selectedTags: [],
                progress: 0,
                loading: false
            }
        },
        mounted() {
            if (this.file !== false) {
                this.fileName = this.file.description;
                this.selectedTags = this.file.tags.map(item => {
                    return {key: item.name, value: item.name}
                });
            }
        },
        methods: {
            closeFileModal() {
                this.$emit('closeFileModal')
            },
            filesChange(event) {
                if (event.target.files[0]) {
                    let fileType = event.target.files[0].type;
                    this.fileDragOver = false;
                    if (fileType.includes('image')) {
                        this.fileName = '';
                        let reader = new FileReader();
                        let file = event.target.files[0];
                        if (event.target.files[0]) {
                            reader.readAsDataURL(file);
                        }
                        reader.onloadend = () => {
                            this.imageBase64 = reader.result;
                        };
                    } else {
                        this.fileName = event.target.files[0].name;
                        this.imageBase64 = null;
                    }
                }
            },
            uploadFile() {
                if (this.progress === 0) {
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            if (this.file === false) {
                                let formData = new FormData(this.$refs.fileUploadModal);
                                let userToken = localStorage.getItem('user-token');
                                axios.post(`${this.$store.state.baseUrl}brand/${this.id}/document`,
                                    formData,
                                    {
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'multipart/form-data',
                                            'Accept-Language': 'en',
                                            'Authorization': `Bearer ${userToken}`
                                        },
                                        onUploadProgress: (progressEvent) => {
                                            this.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                                        }
                                    }
                                ).then(response => {
                                    this.$emit('addFile', response.data);
                                }).catch(() => {
                                    this.progress = 0
                                });
                            } else {
                                let data = {
                                    id: this.id,
                                    fileId: this.file.id,
                                    data: {
                                        description: this.fileName,
                                        tags: this.selectedTags.map(obj => {
                                            return obj.value
                                        })
                                    }
                                };
                                this.loading = true;
                                this.$store.dispatch('editFile', data).then(response => {
                                    this.loading = false;
                                    this.$emit('addFile', response);
                                }).catch(() => {
                                    this.loading = false;
                                })
                            }
                        }
                    });
                } else {
                    this.progress = 0;
                }
            }
        }
    }
</script>

<style scoped>
    .qf-dropzone {
        height: 157px;
    }

    .qf-dropzone.qf-disabled-disabled > .qf-dropbox-content.qf-dropbox-hover img,
    .qf-dropzone.qf-disabled-disabled > .qf-dropbox-content:hover img {
        opacity: 1;
    }

    .qf-dropzone.qf-disabled-disabled > .qf-dropbox-content.qf-dropbox-hover, .qf-dropzone.qf-disabled-disabled > .qf-dropbox-content:hover {
        background: #EDEDED;
        cursor: not-allowed;
    }
</style>
